module.exports = __webpack_public_path__ + "static/media/12.db099fc3.jpeg";